export const SelectedGames = [
  `[Event "Paris"]
  [Site "Paris FRA"]
  [Date "1858.??.??"]
  [EventDate "?"]
  [Round "?"]
  [Result "1-0"]
  [White "Paul Morphy"]
  [Black "Duke Karl / Count Isouard"]
  [ECO "C41"]
  [WhiteElo "?"]
  [BlackElo "?"]
  [PlyCount "33"]

  1.e4 e5 2.Nf3 d6 3.d4 Bg4 {This is a weak move
  already.--Fischer} 4.dxe5 Bxf3 5.Qxf3 dxe5 6.Bc4 Nf6 7.Qb3 Qe7
  8.Nc3 c6 9.Bg5 {Black is in what's like a zugzwang position
  here. He can't develop the [Queen's] knight because the pawn
  is hanging, the bishop is blocked because of the
  Queen.--Fischer} b5 10.Nxb5 cxb5 11.Bxb5+ Nbd7 12.O-O-O Rd8
  13.Rxd7 Rxd7 14.Rd1 Qe6 15.Bxd7+ Nxd7 16.Qb8+ Nxb8 17.Rd8# 1-0`,

  `[Event "US Championship 1963/64"]
 [Site "New York, NY USA"]
 [Date "1963.12.18"]
 [EventDate "1963.??.??"]
 [Round "3"]
 [Result "0-1"]
 [White "Robert Eugene Byrne"]
 [Black "Robert James Fischer"]

 1. d4 {Notes from various sources.} Nf6 2. c4 g6 3. g3 c6
 4. Bg2 d5 5. cxd5 {5.Qb3 maintains more tension. -- Fischer}
 cxd5 6. Nc3 Bg7 7. e3 O-O 8. Nge2 Nc6 9. O-O b6 10. b3 {It's
 hard for either side to introduce an imbalance into this
 essentially symmetrical variation. Deadeye equality also
 ensues afer 10.Nf4 e6 11.b3 Ba6 12.Re1 Rc8 13.Ba3 Re8 14.Rc1
 (Stahlberg-Flohr, Kemeri 1937) -- Fischer} Ba6 11. Ba3 {After
 White's 11th move I should adjudicate his position as slightly
 superior, and at worst completely safe. To turn this into a
 mating position in eleven more moves is more witchcraft than
 chess! Quite honestly, I do not see the man who can stop Bobby
 at this time. -- K.F. Kirby, South African Chess Quarterly}
 Re8 12. Qd2 e5 {! I was a bit worried about weakening my QP,
 but felt that the tremendous activity obtained by my minor
 pieces would permit White no time to exploit it. 12...e6 would
 probably lead to a draw. -- Fischer} 13. dxe5 Nxe5 14. Rfd1
 {"Add another to those melancholy case histories entitled: The
 Wrong Rook." -- Fischer ~ "This is very much a case of 'the
 wrong rook'. One can understand Byrne's desire to break the
 pin on the e2-knight, but this turns out to be less important
 than other considerations. Fischer spends a lot of time and
 energy analysing the superior 14. Rad1!, but still comes to
 the conclusion that Black can keep the advantage." -- John
 Nunn} Nd3 {Now it's all systems go for the Fischer rocket. --
 Robert Wade} 15. Qc2 {There is hardly any other defense to the
 threat of ...Ne4. -- Fischer} Nxf2 {! The key to Black's
 previous play. The complete justification for this sac does
 not become apparent until White resigns! -- Fischer} 16. Kxf2
 Ng4+ 17. Kg1 Nxe3 18. Qd2 {Byrne: As I sat pondering why
 Fischer would choose such a line, because it was so obviously
 lost for Black, there suddenly comes...} Nxg2 {!! This
 dazzling move came as the shocker... the culminating
 combination is of such depth that, even at the very moment at
 which I resigned, both grandmasters who were commenting on the
 play for the spectators in a separate room believed I had a
 won game! -- Robert Byrne} 19. Kxg2 d4 {!} 20. Nxd4 Bb7+ {The
 King is at Black's mercy. -- Fischer} 21. Kf1 {In a room set
 aside for commentaries on the games in progress, two
 grandmasters were stating, for the benefit of the spectators,
 that Byrne had a won game. Byrne's reply to Fischer's next
 move must have been jaw dropping! -- Wade} Qd7 22.Qf2 Qh3+ 23.Kg1 Re1+!! 24.Rxe1 Bxd4 25. Qxd4 Qg2
 {And White
 resigns. Fischer writes: "A bitter disappointment. I'd hoped
 for 22.Qf2 Qh3+ 23.Kg1 Re1+!! 24.Rxe1 Bxd4 with mate to follow
 shortly."} 0-1`,

  `[Event "1st American Chess Congress"]
 [Site "New York, NY USA"]
 [Date "1857.11.03"]
 [EventDate "1857.??.??"]
 [Round "4.6"]
 [Result "0-1"]
 [White "Louis Paulsen"]
 [Black "Paul Morphy"]
 [ECO "C48"]
 [WhiteElo "?"]
 [BlackElo "?"]
 [PlyCount "56"]

 1. e4 e5 2. Nf3 Nc6 3. Nc3 Nf6 4. Bb5 Bc5 5. O-O O-O 6. Nxe5
 Re8 7. Nxc6 dxc6 8. Bc4 b5 9. Be2 Nxe4 10. Nxe4 Rxe4 11. Bf3
 Re6 12. c3 Qd3 13. b4 Bb6 14. a4 bxa4 15. Qxa4 Bd7 16. Ra2
 Rae8 17. Qa6 {Morphy took twelve minutes over his next move,
 probably to assure himself that the combination was sound and
 that he had a forced win in every variation. -- Chernev} Qxf3
 {!!} 18. gxf3 Rg6+ 19. Kh1 Bh3 20. Rd1 {Not 20 Rg1 Rxg1+ 21
 Kxg1 Re1+} Bg2+ 21. Kg1 Bxf3+ 22. Kf1 Bg2+ {The "quiet"
 22...Rg2! would have won more quickly. Zukertort gives: 23.Qd3
 Rxf2+ 24.Kg1 Rg2+ 25.Kh1 Rg1. } 23. Kg1 Bh3+ 24. Kh1 Bxf2
 25. Qf1 {Absolutely forced.} Bxf1 26. Rxf1 Re2 27. Ra1 Rh6
 28. d4 Be3 0-1`,

  `[Event "New York USA"]
 [Site "New York  USA"]
 [Date "1857.??.??"]
 [Round "?"]
 [White "Paul Morphy"]
 [Black "NN"]
 [Result "1-0"]

 1. e4 e5 2. Nf3 Nc6 3. Bc4 Bc5 4. b4 Bxb4 5. c3 Ba5 6. d4 exd4 7. O-O Nf6 8. Ba3
 Bb6 9. Qb3 d5 10. exd5 Na5 11. Re1+ Be6 12. dxe6 Nxb3 13. exf7+ Kd7 14. Be6+ Kc6
 15. Ne5+ Kb5 16. Bc4+ Ka5 17. Bb4+ Ka4 18. axb3# 1-0`,

  `[Event "Wch U14"]
  [Site "Chalkidiki GRE"]
  [Date "2003.10.23"]
  [EventDate "2003.10.25"]
  [Round "1.3"]
  [Result "0-1"]
  [White "Jon Ludvig Hammer"]
  [Black "Magnus Carlsen"]
  [ECO "A46"]
  [WhiteElo "2074"]
  [BlackElo "2450"]
  [PlyCount "34"]

  1. Nf3 d6 2. d4 Nf6 3. Nbd2 g6 4. e4 Bg7 5. Bd3 O-O 6. O-O Nc6
  7. c3 e5 8. h3 Nh5 9. dxe5 Nf4 10. Bb5 Nxe5 11. Nxe5 Qg5
  12. Ng4 Qxb5 13. Nb3 Ne2+ 14. Kh1 Bxg4 15. hxg4 Rae8 16. Be3
  Rxe4 17. Re1 Qh5+ 0-1`,

  `[Event "World-ch31-KK2 Kasparov-Karpov +5-3=16"]
[Site "Moscow"]
[Date "1985.10.15"]
[Round "16"]
[White "Karpov, Anatoly"]
[Black "Kasparov, Garry"]
[Result "0-1"]
[WhiteElo "2720"]
[BlackElo "2700"]
[UTCDate "2021.11.28"]
[UTCTime "19:39:12"]
[Variant "Standard"]
[ECO "B44"]
[Opening "Sicilian Defense: Taimanov Variation, Gary Gambit"]
[Annotator "https://lichess.org/@/Durarbayli"]

1. e4 c5 2. Nf3 e6 3. d4 cxd4 4. Nxd4 Nc6 5. Nb5 d6 6. c4 Nf6 7. N1c3 a6 8. Na3 d5 9. cxd5 exd5 10. exd5 Nb4 11. Be2 Bc5 12. O-O O-O 13. Bf3 Bf5 14. Bg5 Re8 15. Qd2 b5 16. Rad1 Nd3 17. Nab1 h6 18. Bh4 b4 19. Na4 Bd6 20. Bg3 Rc8 21. b3 g5 22. Bxd6 Qxd6 23. g3 Nd7 24. Bg2 Qf6 25. a3 a5 26. axb4 axb4 27. Qa2 Bg6 28. d6 g4 29. Qd2 Kg7 30. f3 Qxd6 31. fxg4 Qd4+ 32. Kh1 Nf6 33. Rf4 Ne4 34. Qxd3 Nf2+ 35. Rxf2 Bxd3 36. Rfd2 Qe3 37. Rxd3 Rc1 38. Nb2 Qf2 39. Nd2 Rxd1+ 40. Nxd1 Re1+ { 0-1 White resigns. } 0-1`,

  `[Event "Latvian championship"]
[Site "Riga URS"]
[Date "1953.??.??"]
[EventDate "?"]
[Round "?"]
[Result "1-0"]
[White "Mikhail Tal"]
[Black "Mark Pasman"]
[ECO "B93"]
[WhiteElo "?"]
[BlackElo "?"]
[PlyCount "80"]

1.e4 c5 2.Nf3 d6 3.d4 cxd4 4.Nxd4 Nf6 5.Nc3 a6 6.f4 e5 7.Nf3
Nbd7 8.Bd3 Be7 9.O-O O-O 10.Kh1 b5 11.a3 Qc7 12.fxe5 dxe5
13.Nh4 Nc5 14.Bg5 Qd8 15.Nf5 Bxf5 16.Rxf5 Nfd7 17.Bxe7 Qxe7
18.Nd5 Qd6 19.Qg4 g6 20.Raf1 f6 21.h4 Kh8 22.R5f3 f5 23.exf5
Qxd5 24.fxg6 Rxf3 25.g7 Kg8 26.Bxh7+ Kxh7 27.Rxf3 Ne4 28.h5
Ndf6 29.Qg6+ Kg8 30.h6 Ra7 31.Kh2 Re7 32.Rh3 Nh7 33.Rd3 Qa8
34.Qxe4 Qxe4 35.Rd8+ Kf7 36.g8=Q+ Kf6 37.Rd6+ Kf5 38.Qg6+ Kf4
39.g3+ Ke3 40.Rd3+ Qxd3 1-0`,

  `
[White "Mikhail Tal"]
[Black "Johann Hjartarson"]
  1. e4 e5 2. Nf3 Nc6 3. Bb5 a6 4. Ba4 Nf6 5. O-O Be7 6. Re1 b5 7. Bb3 O-O 8. c3 d6 9. h3 Na5 10. Bc2 c5 11. d4 Qc7 12. Nbd2 Bd7 13. Nf1 cd4 14. cd4 Rac8 15. Ne3 Nc6 16. d5 Nb4 17. Bb1 a5 18. a3 Na6 19. b4 g6 20. Bd2 ab4 21. ab4 Qb7 22. Bd3 Nc7 23. Nc2 Nh5 24. Be3 Ra8 25. Qd2 Ra1 26. Na1 f5 27. Bh6 Ng7 28. Nb3 f4 29. Na5 Qb6 30. Rc1 Ra8 31. Qc2 Nce8 32. Qb3 Bf6 33. Nc6 Nh5 34. Qb2 Bg7 35. Bg7 Kg7 36. Rc5 Qa6 37. Rb5 Nc7 38. Rb8 Qd3 39. Nce5 Qd1 40. Kh2 Ra1 41. Ng4 Kf7 42. Nh6 Ke7 43. Ng8 44. Kf7 Ng5`,
  `[Event "Sousse Interzonal"]
  [Site "Sousse TUN"]
  [Date "1967.10.15"]
  [EventDate "1967.??.??"]
  [Round "3"]
  [Result "1-0"]
  [White "Robert James Fischer"]
  [Black "Lhamsuren Myagmarsuren"]
  [ECO "A07"]
  [WhiteElo "?"]
  [BlackElo "?"]
  [PlyCount "61"]

  1. e4 e6 2. d3 d5 3. Nd2 Nf6 4. g3 c5 5. Bg2 Nc6 6. Ngf3 Be7
  7. O-O O-O 8. e5 Nd7 9. Re1 b5 10. Nf1 b4 11. h4 a5 12. Bf4 a4
  13. a3 bxa3 14. bxa3 Na5 15. Ne3 Ba6 16. Bh3 d4 17. Nf1 Nb6
  18. Ng5 Nd5 19. Bd2 Bxg5 20. Bxg5 Qd7 21. Qh5 Rfc8 22. Nd2 Nc3
  23. Bf6 Qe8 24. Ne4 g6 25. Qg5 Nxe4 26. Rxe4 c4 27. h5 cxd3
  28. Rh4 Ra7 29. Bg2 dxc2 30. Qh6 Qf8 31. Qxh7+ Kxh7 32. hxg6 Kxg6 33. Be4 1-0`,
  `[Event "Bundesliga 1997/98"]
  [Site "GER"]
  [Date "1997.??.??"]
  [EventDate "?"]
  [Round "2"]
  [Result "0-1"]
  [White "Lubomir Ftacnik"]
  [Black "Ognjen Cvitan"]
  [ECO "E97"]
  [WhiteElo "?"]
  [BlackElo "?"]
  [PlyCount "52"]

  1. d4 Nf6 2. Nf3 g6 3. c4 Bg7 4. Nc3 O-O 5. e4 d6 6. Be2 e5
  7. O-O Nc6 8. d5 Ne7 9. Nd2 Ne8 10. b4 f5 11. c5 Nf6 12. f3 f4
  13. Nc4 g5 14. a4 Ng6 15. Ba3 Rf7 16. b5 dxc5 17. Bxc5 h5
  18. a5 g4 19. b6 g3 20. Kh1 Nh7 21. d6 Qh4 22. Bg1 Bh3
  23. bxc7 Bxg2+ 24. Kxg2 Qh3+ 25. Kxh3 Ng5+ 26. Kg2 Nh4+ Kh1 g2 0-1`,
];
